import {
	BrowserRouter as Router,
	Routes,
	Route,
	useLocation,
} from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import LoadingBar from "react-top-loading-bar";
import LoginPage from "./Components/Authentication/Login";
import DevelopmentLogin from "./Components/Authentication/DevelopmentLogin";
import SurveyList from "./Components/Survey/SurveyList";
import Layout from "./Components/Layout/Layout";
import AddQuestions from "./Components/Survey/AddQuestions";
import AddQuestionPanel from "./Components/Survey/AddQuestionPanel";
import ManageSurvey from "./Components/Survey/ManageSurvey";
import CreateSurvey from "./Components/Survey/CreateSurvey";
import ScrollToTop from "./Components/ScrollToTop";
import ParticipantResponse from "./Components/Survey/ParticipantResponse";
import ManageResponder from "./Components/Survey/ManagerResponder";
import Footer from "./Components/Footer";

function TokenHandler() {
	const [token, setToken] = useState(localStorage.getItem("JWTToken"));
	const location = useLocation();
	const loadingRef = useRef(null);

	useEffect(() => {
		if (loadingRef.current) {
			loadingRef.current.continuousStart();
			const timer = setTimeout(() => {
				loadingRef.current.complete();
			}, 500);
			return () => clearTimeout(timer);
		}
	}, [location.pathname]);

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const urlToken = urlParams.get("token");

		if (urlToken) {
			localStorage.setItem("JWTToken", urlToken);
			setToken(urlToken);
			window.history.replaceState({}, document.title, window.location.pathname);
		}
	}, []);

	return (
		<>
			<LoadingBar color="#3bb290" height={3} ref={loadingRef} />
			<Routes>
				<Route
					path="/"
					element={
						<div className="flex flex-col min-h-screen">
							<div className="flex-grow">
								<LoginPage />
								{/* <DevelopmentLogin /> */}
							</div>
						</div>
					}
				/>
				<Route
					path="/survey-list"
					element={
						<Layout>
							<SurveyList />
						</Layout>
					}
				/>
				<Route
					path="/"
					element={
						<Layout>
							<SurveyList />
						</Layout>
					}
				/>
				<Route
					path="/create-Survey"
					element={
						<Layout>
							<CreateSurvey />
						</Layout>
					}
				/>
				<Route
					path="/add-questions/:assessmentUID"
					element={
						<Layout>
							<AddQuestions />
						</Layout>
					}
				/>
				<Route
					path="/Manage-Responder/:assessmentUID"
					element={
						<Layout>
							<ManageResponder />
						</Layout>
					}
				/>
				<Route
					path="/Participant-Response/:responderUID"
					element={<ParticipantResponse />}
				/>
			</Routes>
		</>
	);
}

function App() {
	return (
		<Router>
			<ScrollToTop />
			<TokenHandler />
		</Router>
	);
}

export default App;
